import {current} from "@reduxjs/toolkit";
import {Schedule} from "../../../../types/schedule/schedule";
import {ScheduleDto, SchedulePageDto,} from "../../../../types/schedule/schedule-dto";
import {convertScheduleDtoToSchedule} from "../../../../utils/converter/schedule/schedule-converter";
import {ScheduleState} from "../../../type/schedule-state";

interface Action {
    type: string;
    payload: {
        schedulePageAllDto: SchedulePageDto;
    };
}

export const addSchedulePageDispatch = (
    state: ScheduleState,
    action: Action
) => {
    const {schedulePageAllDto} = action.payload;

    let contents = current(state).schedulePageAll.contents;

    const newContents: Schedule[] = [];
    schedulePageAllDto.contents.forEach((scheduleDto: ScheduleDto) => {
        if (contents.find((content) => content.id === scheduleDto.id)) {
            return;
        } else {
            newContents.push(convertScheduleDtoToSchedule(scheduleDto));
        }
    });
    contents = contents.concat(newContents);

    state.schedulePageAll = {
        contents: contents,
        first: schedulePageAllDto.first,
        last: schedulePageAllDto.last,
        page: schedulePageAllDto.page,
        totalPages: schedulePageAllDto.totalPages,
        totalElements: schedulePageAllDto.totalElements,
    };
};
